import { SchoolProps } from '../types/SchoolProps';
import { calcDistance } from './calcDistance';

export const filterGender = (gender: string, schools: SchoolProps[]) => {
    switch (gender) {
      case 'Boys':
        const boysSchools = schools.filter(
          (school) => school.gender === 'BOYS'
        );
        return boysSchools;
      case 'Girls':
        const girlsSchools = schools.filter(
          (school) => school.gender === 'GIRLS'
        );
        return girlsSchools;
      case 'Co-ed (mixed)':
        const coEdSchools = schools.filter(
          (school) => school.gender === 'CO-ED'
        );
        return coEdSchools;
      default:
        return schools;
    }
  };

export const filterEducation = (educationLevel: string, schools: SchoolProps[]) => {
    switch (educationLevel) {
      case 'Primary':
        const primarySchools = schools.filter(
          (school) => school.school_level === 'Primary'
        );
        return primarySchools;
      case 'Secondary':
        const secondarySchools = schools.filter(
          (school) => school.school_level === 'Secondary'
        );
        return secondarySchools;
      case 'Specialist School':
        const combinedSchools = schools.filter(
          (school) => school.school_level === 'Special'
        );
        return combinedSchools;
      case 'K-12':
        const k12Schools = schools.filter(
          (school) => school.school_level === 'Sec/Prim'
        );
        return k12Schools;
      default:
        return schools;
    }
  };

const findNearbySchools = async (allSchools: SchoolProps[], selectedGender: string, selectedEducation: string, locationCoords: { lat: number; lng: number }): Promise<SchoolProps[]> => {

    let nearbySchools = [...allSchools];

    // Filter by distance
    nearbySchools = nearbySchools.filter((school) => {
      const destCoords = { lat: school.lat, lng: school.long };
      const distance = calcDistance(locationCoords, destCoords);
      return distance <= 5;
    });

    // Filter Gender
    if (selectedGender !== 'All') {
        nearbySchools = filterGender(selectedGender, nearbySchools);
    }
    // Filter Education
    if (selectedEducation !== 'All') {
        nearbySchools = filterEducation(selectedEducation, nearbySchools);
    }

    return nearbySchools;
}

export default findNearbySchools;